// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentBlock_payment-form-wrapper__-AFMM {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.paymentBlock_payment-actions__m028r {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
.paymentBlock_payment-actions__m028r .paymentBlock_cancel-button__rdq9z {
  background-color: #f0f0f0;
  color: #333;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: none;
}
.paymentBlock_payment-actions__m028r .paymentBlock_cancel-button__rdq9z:hover, .paymentBlock_payment-actions__m028r .paymentBlock_cancel-button__rdq9z:active, .paymentBlock_payment-actions__m028r .paymentBlock_cancel-button__rdq9z:focus {
  background-color: #f0f0f0;
  color: #333;
}
.paymentBlock_payment-actions__m028r button[type=submit] {
  margin-left: 18px;
  background-color: #ff6a00;
  color: white;
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: none;
}
.paymentBlock_payment-actions__m028r button[type=submit]:hover, .paymentBlock_payment-actions__m028r button[type=submit]:active, .paymentBlock_payment-actions__m028r button[type=submit]:focus {
  background-color: #ff6a00;
  color: white;
}

.paymentBlock_radio__aLncR {
  transform: scale(2.5);
  cursor: pointer;
  width: 10px;
  height: 10px;
}

label {
  font-size: 20px;
  font-weight: 350;
  color: #4b4848;
  margin-left: 15px;
}

.paymentBlock_success-block__skuHR {
  margin-top: 24px;
  padding: 20px;
  border: 2px solid #4caf50;
  border-radius: 8px;
  background-color: #e8f5e9;
  color: #2e7d32;
}
.paymentBlock_success-block__skuHR .paymentBlock_success-title__LbfZQ {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
}
.paymentBlock_success-block__skuHR .paymentBlock_success-checkmark__Q\\+Ij5 {
  font-size: 32px;
  margin-bottom: 12px;
}
.paymentBlock_success-block__skuHR p {
  font-size: 16px;
  margin: 4px 0;
}
.paymentBlock_success-block__skuHR strong {
  font-weight: 600;
}

.paymentBlock_paymentActions__K399y {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 18px;
}
.paymentBlock_paymentActions__K399y .paymentBlock_cancelButton__Py5kO {
  background-color: #cfd5df;
  color: #ffffff;
  padding: 13px 26px;
  border-radius: 0px;
  text-decoration: none;
  font-weight: 700;
  transition: none;
  line-height: 1.2;
  min-width: 160px;
  font-size: 26px;
  text-align: center;
}
.paymentBlock_paymentActions__K399y .paymentBlock_cancelButton__Py5kO:hover, .paymentBlock_paymentActions__K399y .paymentBlock_cancelButton__Py5kO:active, .paymentBlock_paymentActions__K399y .paymentBlock_cancelButton__Py5kO:focus {
  background-color: #cfd5df;
  text-decoration: underline;
}
.paymentBlock_paymentActions__K399y .paymentBlock_submitButton__JQ1qa {
  background-color: #ffb034;
  color: #ffffff;
  padding: 13px 26px;
  min-width: 160px;
  font-size: 26px;
  border: none;
  border-radius: 0px;
  font-weight: 700;
  cursor: pointer;
  transition: none;
  text-align: center;
  text-decoration: none;
  line-height: 1.2;
}
.paymentBlock_paymentActions__K399y .paymentBlock_submitButton__JQ1qa:hover, .paymentBlock_paymentActions__K399y .paymentBlock_submitButton__JQ1qa:active, .paymentBlock_paymentActions__K399y .paymentBlock_submitButton__JQ1qa:focus {
  text-decoration: underline;
}
.paymentBlock_paymentActions__K399y .paymentBlock_submitButton__JQ1qa:disabled {
  opacity: 0.5 !important;
  text-decoration: none;
}

.paymentBlock_success-block__skuHR {
  position: relative;
  padding: 24px;
  border-radius: 8px;
  background: #f9fff9;
}

.paymentBlock_success-close__sFcl3 {
  position: relative;
  top: 8px;
  right: 12px;
  font-size: 28px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  line-height: 1;
  z-index: 10;
  -webkit-user-select: none;
          user-select: none;
}
.paymentBlock_success-close__sFcl3:hover {
  color: #333;
}

.paymentBlock_title__NzBy6 {
  color: #9e9e9e;
  /* replace with your desired hex color */
}

h3.paymentBlock_title__NzBy6 {
  font-size: 24px;
  font-weight: 300;
  padding-left: 15px;
}

.paymentBlock_container__BLT5h {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 16px;
}

.paymentBlock_row__HBmmj {
  width: 100%;
  display: flex;
  justify-content: center;
}

.paymentBlock_col__4bVv\\+ {
  width: 100%;
  max-width: 980px;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

/* Button base */
.paymentBlock_btn__fE2Bv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.paymentBlock_btnLarge__fEHSe {
  font-size: 1.125rem;
  padding: 1.25rem 2rem;
}

.paymentBlock_btn__fE2Bv:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.12);
  transform: translateY(-1px);
}

/* Gray link-like button */
.paymentBlock_btnGray__7UaDO {
  background-color: #e6e6e6;
  color: #222;
  box-shadow: none;
}
.paymentBlock_btnGray__7UaDO:hover {
  filter: brightness(0.98);
}
.paymentBlock_btnGray__7UaDO:active {
  transform: translateY(0);
}

/* Orange primary button */
.paymentBlock_btnOrange__iF8L- {
  background-color: #ff8a00;
  color: #fff;
  box-shadow: 0 6px 18px rgba(255, 138, 0, 0.18);
}
.paymentBlock_btnOrange__iF8L-:hover {
  filter: brightness(0.97);
}
.paymentBlock_btnOrange__iF8L-:active {
  transform: translateY(1px);
}

.paymentBlock_printBtn__ZQxNr {
  order: 2;
}

/* Responsive */
@media (max-width: 640px) {
  .paymentBlock_col__4bVv\\+ {
    justify-content: center;
    gap: 0.5rem;
  }
  .paymentBlock_btnLarge__fEHSe {
    width: 100%;
    padding: 0.9rem 1rem;
    font-size: 1rem;
  }
  .paymentBlock_printBtn__ZQxNr {
    order: 1;
  }
}
.paymentBlock_paymentMethod-border__CNFcX {
  border: 1px solid #6c757d !important;
  padding: 16px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.paymentBlock_paymentMethod-border__CNFcX input {
  width: 20px;
  height: 20px;
}
.paymentBlock_paymentMethod-border__CNFcX label {
  font-size: 24px;
  font-weight: 300;
}

.paymentBlock_g-font-size-24__eZ\\+hZ,
.paymentBlock_gfs-24__IVKg- {
  font-size: 24px !important;
}

.paymentBlock_g-font-weight-300__aNYVD,
.paymentBlock_gfw-3__6OJWg {
  font-weight: 300 !important;
}

.paymentBlock_btn-gray-light__fEzNC {
  color: #212529;
  background-color: #dddfe3 !important;
  border-color: #e6e9ee;
}
.paymentBlock_btn-gray-light__fEzNC:hover {
  background-color: #E6E9EE !important;
  text-decoration: underline;
}

.paymentBlock_btn-primary__MJDK1 {
  background-color: #ffb034 !important;
  color: #fff !important;
}
.paymentBlock_btn-primary__MJDK1:hover {
  text-decoration: underline;
}

.paymentBlock_btn-lg__zfDRk {
  padding-top: 7px !important;
  padding-bottom: 10px !important;
  font-size: 26px !important;
  border-radius: 0px !important;
  font-weight: 600 !important;
}

.paymentBlock_text-white__6OrYC {
  color: #fff !important;
}

.paymentBlock_mb-10__7rlMS {
  margin-bottom: 10px !important;
}

.paymentBlock_tru-mma-main-add__Gv2fW, .paymentBlock_tru-mma-main-content-box__9uMhK, .paymentBlock_tru-mma-main-service-box__Cg9vq {
  border: 1px solid #6c757d;
}

.paymentBlock_tru-mma-main-add__Gv2fW label {
  text-align: left;
}

@media (max-width: 767px) {
  .paymentBlock_tru-mma-main-service-box__Cg9vq {
    padding: 0 10px !important;
  }
  .paymentBlock_tru-mma-main-content-box__9uMhK {
    padding: 0 10px !important;
  }
  .paymentBlock_tru-mma-main-add__Gv2fW {
    margin: 0 !important;
  }
  .paymentBlock_tru-mma-main-add__Gv2fW label {
    text-align: left;
  }
  .paymentBlock_p-0__5-7Ii {
    padding: 10px !important;
  }
  .paymentBlock_paymentActions__K399y {
    flex-direction: column;
  }
  .paymentBlock_paymentActions__K399y .paymentBlock_cancelButton__Py5kO {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .paymentBlock_mob-p-16__TJq1O.p-0 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .paymentBlock_mob-p-16__TJq1O.px-5 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
.paymentBlock_mb-16__XF6QN {
  margin-bottom: 16px !important;
}

.paymentBlock_g-font-size-16__ra94i, .paymentBlock_gfs-16__zE8Iv {
  font-size: 16px !important;
}

.paymentBlock_g-font-weight-300__aNYVD, .paymentBlock_gfw-3__6OJWg {
  font-weight: 300 !important;
}

.paymentBlock_g-line-height-1_2__fpD84, .paymentBlock_glh-1_2__46rNj {
  line-height: 1.2 !important;
}

.paymentBlock_p-16__IzqCo {
  padding: 16px !important;
}

.paymentBlock_mr-10__XMgb5 {
  margin-right: 10px !important;
}

.paymentBlock_tg-rd-button__nznFW {
  -webkit-appearance: radio !important;
}

.paymentBlock_m-0__ZKYMH {
  margin: 0 !important;
}

.paymentBlock_g-font-size-24__eZ\\+hZ, .paymentBlock_gfs-24__IVKg- {
  font-size: 24px !important;
}

.paymentBlock_g-font-weight-300__aNYVD, .paymentBlock_gfw-3__6OJWg {
  font-weight: 300 !important;
}

.paymentBlock_g-line-height-1__Bhzvz, .paymentBlock_glh-1__px0k5 {
  line-height: 1 !important;
}

.paymentBlock_w-100__GT58Z {
  width: 99.9% !important;
}

.paymentBlock_btn__fE2Bv:not(:disabled):not(.paymentBlock_disabled__oEBND), .paymentBlock_form-control-file__MbxFl:not(:disabled):not(.paymentBlock_disabled__oEBND):after {
  cursor: pointer;
}

.paymentBlock_btn-lg__zfDRk:not([class*=btn-outline]), .paymentBlock_btn-sm__h10d7:not([class*=btn-outline]), .paymentBlock_btn__fE2Bv:not([class*=btn-outline]), .paymentBlock_form-control-file__MbxFl:not([class*=btn-outline]):after {
  border-color: transparent;
}

.paymentBlock_btn-lg__zfDRk {
  min-width: 185px;
}

.paymentBlock_btn__fE2Bv {
  line-height: 1.3em !important;
  white-space: unset;
}

.paymentBlock_btn-lg__zfDRk {
  min-width: 160px !important;
}

@media (min-width: 768px) {
  .paymentBlock_mb-md-0__LN0i5 {
    margin-bottom: 0 !important;
  }
}
.paymentBlock_mb-20__2fQke {
  margin-bottom: 20px !important;
}

.paymentBlock_text-white__6OrYC {
  color: #fff !important;
}

.paymentBlock_mr-10__XMgb5 {
  margin-right: 10px !important;
}

.paymentBlock_loaderOverlay__Xhb\\+H {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1400;
  background: rgba(6, 8, 15, 0.25);
  pointer-events: auto;
}

/* ensure loader child doesn't push to the right */
.paymentBlock_loaderOverlay__Xhb\\+H > * {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  float: none !important;
  width: auto !important;
}

@media only screen and (max-width: 767px) {
  .paymentBlock_mob-btn-width__GvUhr {
    flex-direction: column !important;
    width: 91% !important;
    margin: 0 auto !important;
  }
  .paymentBlock_mob-btn-width__GvUhr .paymentBlock_mb-20__2fQke {
    margin-bottom: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/paymentBlock.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;AACJ;AACI;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AACR;AACQ;EAGI,yBAAA;EACA,WAAA;AADZ;AAKI;EACI,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAHR;AAKQ;EAGI,yBAAA;EACA,YAAA;AALZ;;AAWA;EACI,qBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AARJ;;AAWA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AARJ;;AAWA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AARJ;AAUI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AARR;AAWI;EACI,eAAA;EACA,mBAAA;AATR;AAYI;EACI,eAAA;EACA,aAAA;AAVR;AAaI;EACI,gBAAA;AAXR;;AAeA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAZJ;AAcI;EACI,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAZR;AAaQ;EAGI,yBAAA;EACA,0BAAA;AAbZ;AAiBI;EACI,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AAfR;AAiBQ;EAGI,0BAAA;AAjBZ;AAmBQ;EACI,uBAAA;EACA,qBAAA;AAjBZ;;AAsBA;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AAnBJ;AAqBI;EACI,WAAA;AAnBR;;AAuBA;EACI,cAAA;EACA,wCAAA;AApBJ;;AAuBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AApBJ;;AAuBA;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;AApBJ;;AAoCA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAjCJ;;AAoCA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,SAnBE;EAoBF,mBAAA;EACA,eAAA;AAjCJ;;AAoCA,gBAAA;AACA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAlCK;EAmCL,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,uDAAA;EACA,yBAAA;UAAA,iBAAA;EACA,wCAAA;AAjCJ;;AAoCA;EACI,mBA3CW;EA4CX,qBAAA;AAjCJ;;AAoCA;EACI,aAAA;EACA,6CAzCY;EA0CZ,2BAAA;AAjCJ;;AAoCA,0BAAA;AACA;EACI,yBAnDM;EAoDN,WAnDQ;EAoDR,gBAAA;AAjCJ;AAmCI;EACI,wBAAA;AAjCR;AAoCI;EACI,wBAAA;AAlCR;;AAsCA,0BAAA;AACA;EACI,yBAhEQ;EAiER,WAhEU;EAiEV,8CAAA;AAnCJ;AAqCI;EACI,wBAAA;AAnCR;AAsCI;EACI,0BAAA;AApCR;;AAwCA;EACI,QAAA;AArCJ;;AAwCA,eAAA;AACA;EACI;IACI,uBAAA;IACA,WAAA;EArCN;EAwCE;IACI,WAAA;IACA,oBAAA;IACA,eAAA;EAtCN;EAyCE;IACI,QAAA;EAvCN;AACF;AA0CA;EACI,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAxCJ;AAyCI;EACI,WAAA;EACA,YAAA;AAvCR;AAyCI;EACI,eAAA;EACA,gBAAA;AAvCR;;AA2CA;;EAEI,0BAAA;AAxCJ;;AA2CA;;EAEI,2BAAA;AAxCJ;;AA2CA;EACI,cAAA;EACA,oCAAA;EACA,qBAAA;AAxCJ;AAyCI;EACI,oCAAA;EACA,0BAAA;AAvCR;;AA2CA;EACI,oCAAA;EACA,sBAAA;AAxCJ;AAyCI;EACI,0BAAA;AAvCR;;AA2CA;EACI,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;AAxCJ;;AA2CA;EACI,sBAAA;AAxCJ;;AA6CA;EACI,8BAAA;AA1CJ;;AA4CC;EACG,yBAAA;AAzCJ;;AA4CI;EACI,gBAAA;AAzCR;;AA4CA;EACI;IACI,0BAAA;EAzCN;EA2CE;IACI,0BAAA;EAzCN;EA2CE;IACI,oBAAA;EAzCN;EA0CM;IACI,gBAAA;EAxCV;EA2CE;IACI,wBAAA;EAzCN;EA2CE;IACI,sBAAA;EAzCN;EA0CM;IACI,gBAAA;IACA,mBAAA;EAxCV;EA2CE;IACI,6BAAA;IACA,8BAAA;EAzCN;EA2CE;IACI,6BAAA;IACA,8BAAA;EAzCN;AACF;AA2CA;EACI,8BAAA;AAzCJ;;AA2CA;EACI,0BAAA;AAxCJ;;AA0CA;EACI,2BAAA;AAvCJ;;AAyCA;EACI,2BAAA;AAtCJ;;AAwCA;EACI,wBAAA;AArCJ;;AAuCA;EACI,6BAAA;AApCJ;;AAsCA;EACI,oCAAA;AAnCJ;;AAqCA;EACI,oBAAA;AAlCJ;;AAoCA;EACI,0BAAA;AAjCJ;;AAmCA;EACI,2BAAA;AAhCJ;;AAkCA;EACI,yBAAA;AA/BJ;;AAiCA;EACI,uBAAA;AA9BJ;;AAgCA;EACI,eAAA;AA7BJ;;AA+BA;EACI,yBAAA;AA5BJ;;AA8BC;EACG,gBAAA;AA3BJ;;AA6BC;EACG,6BAAA;EACA,kBAAA;AA1BJ;;AA4BC;EACG,2BAAA;AAzBJ;;AA2BA;EACI;IACI,2BAAA;EAxBN;AACF;AA0BA;EACI,8BAAA;AAxBJ;;AA0BA;EACI,sBAAA;AAvBJ;;AA0BA;EACI,6BAAA;AAvBJ;;AA2BA;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gCAAA;EACA,oBAAA;AAxBJ;;AA2BA,kDAAA;AACA;EACI,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;AAxBJ;;AA0BA;EACI;IACI,iCAAA;IACA,qBAAA;IACA,yBAAA;EAvBN;EAwBM;IACI,6BAAA;EAtBV;AACF","sourcesContent":[".payment-form-wrapper {\n    margin-top: 16px;\n    padding: 16px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n}\n\n.payment-actions {\n    margin-top: 16px;\n    display: flex;\n    justify-content: flex-end;\n\n    .cancel-button {\n        background-color: #f0f0f0;\n        color: #333;\n        padding: 8px 16px;\n        border: none;\n        border-radius: 4px;\n        text-decoration: none;\n        font-weight: 500;\n        transition: none;\n\n        &:hover,\n        &:active,\n        &:focus {\n            background-color: #f0f0f0;\n            color: #333;\n        }\n    }\n\n    button[type=\"submit\"] {\n        margin-left: 18px;\n        background-color: #ff6a00;\n        color: white;\n        padding: 8px 20px;\n        border: none;\n        border-radius: 4px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: none;\n\n        &:hover,\n        &:active,\n        &:focus {\n            background-color: #ff6a00;\n            color: white;\n        }\n    }\n}\n\n\n.radio {\n    transform: scale(2.5);\n    cursor: pointer;\n    width: 10px;\n    height: 10px;\n}\n\nlabel {\n    font-size: 20px;\n    font-weight: 350;\n    color: #4b4848;\n    margin-left: 15px;\n}\n\n.success-block {\n    margin-top: 24px;\n    padding: 20px;\n    border: 2px solid #4caf50;\n    border-radius: 8px;\n    background-color: #e8f5e9;\n    color: #2e7d32;\n\n    .success-title {\n        font-size: 20px;\n        font-weight: 600;\n        margin-bottom: 8px;\n    }\n\n    .success-checkmark {\n        font-size: 32px;\n        margin-bottom: 12px;\n    }\n\n    p {\n        font-size: 16px;\n        margin: 4px 0;\n    }\n\n    strong {\n        font-weight: 600;\n    }\n}\n\n.paymentActions {\n    margin-top: 16px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 18px; // spacing between Cancel and Submit\n\n    .cancelButton {\n        background-color: #cfd5df;\n        color: #ffffff;\n        padding: 13px 26px;\n        border-radius: 0px;\n        text-decoration: none;\n        font-weight: 700;\n        transition: none;\n        line-height: 1.2;\n        min-width: 160px;\n        font-size: 26px;\n        text-align: center;\n        &:hover,\n        &:active,\n        &:focus {\n            background-color: #cfd5df;\n            text-decoration: underline;\n        }\n    }\n\n    .submitButton {\n        background-color: #ffb034;\n        color: #ffffff;\n        padding: 13px 26px;\n        min-width: 160px;\n        font-size: 26px;\n        border: none;\n        border-radius: 0px;\n        font-weight: 700;\n        cursor: pointer;\n        transition: none;\n        text-align: center;\n        text-decoration: none;\n        line-height: 1.2;\n\n        &:hover,\n        &:active,\n        &:focus {\n            text-decoration: underline;\n        }\n        &:disabled{\n            opacity: 0.5 !important;\n            text-decoration: none;\n        }\n    }\n}\n\n.success-block {\n    position: relative;\n    padding: 24px;\n    border-radius: 8px;\n    background: #f9fff9;\n}\n\n.success-close {\n    position: relative;\n    top: 8px;\n    right: 12px;\n    font-size: 28px;\n    font-weight: bold;\n    color: #000;\n    cursor: pointer;\n    line-height: 1;\n    z-index: 10;\n    user-select: none;\n\n    &:hover {\n        color: #333;\n    }\n}\n\n.title {\n    color: #9e9e9e;\n    /* replace with your desired hex color */\n\n}\nh3.title{\n    font-size: 24px;\n    font-weight: 300;\n    padding-left: 15px;\n}\n\n.container {\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    padding: 16px;\n}\n\n// paymentBlock.module.scss\n\n$radius: 8px;\n$font-size-lg: 1.125rem;\n$padding-vertical: 1.25rem;\n$padding-horizontal: 2rem;\n$gap: 1rem;\n$gray-bg: #e6e6e6;\n$gray-text: #222;\n$orange-bg: #ff8a00;\n$orange-text: #fff;\n$focus-outline: 0 0 0 3px rgba(0, 123, 255, 0.12);\n\n.row {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.col {\n    width: 100%;\n    max-width: 980px;\n    padding: 0 1rem;\n    display: flex;\n    justify-content: center;\n    gap: $gap;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n/* Button base */\n.btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    border-radius: $radius;\n    font-weight: 600;\n    text-decoration: none;\n    cursor: pointer;\n    transition: transform 120ms ease, box-shadow 120ms ease;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.btnLarge {\n    font-size: $font-size-lg;\n    padding: $padding-vertical $padding-horizontal;\n}\n\n.btn:focus {\n    outline: none;\n    box-shadow: $focus-outline;\n    transform: translateY(-1px);\n}\n\n/* Gray link-like button */\n.btnGray {\n    background-color: $gray-bg;\n    color: $gray-text;\n    box-shadow: none;\n\n    &:hover {\n        filter: brightness(0.98);\n    }\n\n    &:active {\n        transform: translateY(0);\n    }\n}\n\n/* Orange primary button */\n.btnOrange {\n    background-color: $orange-bg;\n    color: $orange-text;\n    box-shadow: 0 6px 18px rgba(255, 138, 0, 0.18);\n\n    &:hover {\n        filter: brightness(0.97);\n    }\n\n    &:active {\n        transform: translateY(1px);\n    }\n}\n\n.printBtn {\n    order: 2;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n    .col {\n        justify-content: center;\n        gap: 0.5rem;\n    }\n\n    .btnLarge {\n        width: 100%;\n        padding: 0.9rem 1rem;\n        font-size: 1rem;\n    }\n\n    .printBtn {\n        order: 1;\n    }\n}\n\n.paymentMethod-border {\n    border: 1px solid #6c757d !important;\n    padding: 16px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    input{\n        width: 20px;\n        height: 20px;\n    }\n    label{\n        font-size: 24px;\n        font-weight: 300;\n    }\n}\n\n.g-font-size-24,\n.gfs-24 {\n    font-size: 24px !important;\n}\n\n.g-font-weight-300,\n.gfw-3 {\n    font-weight: 300 !important;\n}\n\n.btn-gray-light {\n    color: #212529;\n    background-color: #dddfe3 !important;\n    border-color: #e6e9ee;\n    &:hover{\n        background-color: #E6E9EE !important;\n        text-decoration: underline;\n    }\n}\n\n.btn-primary {\n    background-color: #ffb034 !important;\n    color: #fff !important;\n    &:hover{\n        text-decoration: underline;\n    }\n}\n\n.btn-lg {\n    padding-top: 7px !important;\n    padding-bottom: 10px !important;\n    font-size: 26px !important;\n    border-radius: 0px !important;\n    font-weight: 600 !important;\n}\n\n.text-white {\n    color: #fff !important;\n}\n\n\n// New\n.mb-10 {\n    margin-bottom: 10px !important;\n}\n .tru-mma-main-add,  .tru-mma-main-content-box,  .tru-mma-main-service-box {\n    border: 1px solid #6c757d;\n}\n.tru-mma-main-add{\n    label{\n        text-align: left;\n    }\n}\n@media (max-width: 767px) {\n    .tru-mma-main-service-box{\n        padding: 0 10px !important;\n    }\n    .tru-mma-main-content-box{\n        padding: 0 10px !important;\n    }\n    .tru-mma-main-add{\n        margin: 0 !important;        \n        label{\n            text-align: left;\n        }\n    }\n    .p-0 {\n        padding: 10px !important;\n    }\n    .paymentActions{\n        flex-direction: column;\n        .cancelButton{\n            margin-top: 30px;\n            margin-bottom: 30px;\n        }\n    }\n    .mob-p-16:global(.p-0){\n        padding-left: 16px !important;\n        padding-right: 16px !important;        \n    }\n    .mob-p-16:global(.px-5){\n        padding-left: 16px !important;\n        padding-right: 16px !important;\n    }\n}\n.mb-16 {\n    margin-bottom: 16px !important;\n}\n.g-font-size-16, .gfs-16 {\n    font-size: 16px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.p-16 {\n    padding: 16px !important;\n}\n.mr-10 {\n    margin-right: 10px !important;\n}\n.tg-rd-button {\n    -webkit-appearance: radio !important;\n}\n.m-0 {\n    margin: 0 !important;\n}\n.g-font-size-24, .gfs-24 {\n    font-size: 24px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-line-height-1, .glh-1 {\n    line-height: 1 !important;\n}\n.w-100 {\n    width: 99.9% !important;\n}\n.btn:not(:disabled):not(.disabled), .form-control-file:not(:disabled):not(.disabled):after {\n    cursor: pointer;\n}\n.btn-lg:not([class*=btn-outline]), .btn-sm:not([class*=btn-outline]), .btn:not([class*=btn-outline]), .form-control-file:not([class*=btn-outline]):after {\n    border-color: transparent;\n}\n .btn-lg {\n    min-width: 185px;\n}\n .btn {\n    line-height: 1.3em !important;\n    white-space: unset;\n}\n .btn-lg {\n    min-width: 160px !important;\n}\n@media (min-width: 768px) {\n    .mb-md-0 {\n        margin-bottom: 0 !important;\n    }\n}\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n.text-white {\n    color: #fff !important;\n}\n\n.mr-10 {\n    margin-right: 10px !important;\n}\n\n\n.loaderOverlay {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1400;\n    background: rgba(6, 8, 15, 0.25);\n    pointer-events: auto;\n}\n\n/* ensure loader child doesn't push to the right */\n.loaderOverlay>* {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin: 0 !important;\n    float: none !important;\n    width: auto !important;\n}\n@media only screen and (max-width: 767px) {\n    .mob-btn-width{\n        flex-direction: column !important;\n        width: 91% !important;\n        margin: 0 auto !important;\n        .mb-20{\n            margin-bottom: 0px !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payment-form-wrapper": `paymentBlock_payment-form-wrapper__-AFMM`,
	"payment-actions": `paymentBlock_payment-actions__m028r`,
	"cancel-button": `paymentBlock_cancel-button__rdq9z`,
	"radio": `paymentBlock_radio__aLncR`,
	"success-block": `paymentBlock_success-block__skuHR`,
	"success-title": `paymentBlock_success-title__LbfZQ`,
	"success-checkmark": `paymentBlock_success-checkmark__Q+Ij5`,
	"paymentActions": `paymentBlock_paymentActions__K399y`,
	"cancelButton": `paymentBlock_cancelButton__Py5kO`,
	"submitButton": `paymentBlock_submitButton__JQ1qa`,
	"success-close": `paymentBlock_success-close__sFcl3`,
	"title": `paymentBlock_title__NzBy6`,
	"container": `paymentBlock_container__BLT5h`,
	"row": `paymentBlock_row__HBmmj`,
	"col": `paymentBlock_col__4bVv+`,
	"btn": `paymentBlock_btn__fE2Bv`,
	"btnLarge": `paymentBlock_btnLarge__fEHSe`,
	"btnGray": `paymentBlock_btnGray__7UaDO`,
	"btnOrange": `paymentBlock_btnOrange__iF8L-`,
	"printBtn": `paymentBlock_printBtn__ZQxNr`,
	"paymentMethod-border": `paymentBlock_paymentMethod-border__CNFcX`,
	"g-font-size-24": `paymentBlock_g-font-size-24__eZ+hZ`,
	"gfs-24": `paymentBlock_gfs-24__IVKg-`,
	"g-font-weight-300": `paymentBlock_g-font-weight-300__aNYVD`,
	"gfw-3": `paymentBlock_gfw-3__6OJWg`,
	"btn-gray-light": `paymentBlock_btn-gray-light__fEzNC`,
	"btn-primary": `paymentBlock_btn-primary__MJDK1`,
	"btn-lg": `paymentBlock_btn-lg__zfDRk`,
	"text-white": `paymentBlock_text-white__6OrYC`,
	"mb-10": `paymentBlock_mb-10__7rlMS`,
	"tru-mma-main-add": `paymentBlock_tru-mma-main-add__Gv2fW`,
	"tru-mma-main-content-box": `paymentBlock_tru-mma-main-content-box__9uMhK`,
	"tru-mma-main-service-box": `paymentBlock_tru-mma-main-service-box__Cg9vq`,
	"p-0": `paymentBlock_p-0__5-7Ii`,
	"mob-p-16": `paymentBlock_mob-p-16__TJq1O`,
	"mb-16": `paymentBlock_mb-16__XF6QN`,
	"g-font-size-16": `paymentBlock_g-font-size-16__ra94i`,
	"gfs-16": `paymentBlock_gfs-16__zE8Iv`,
	"g-line-height-1_2": `paymentBlock_g-line-height-1_2__fpD84`,
	"glh-1_2": `paymentBlock_glh-1_2__46rNj`,
	"p-16": `paymentBlock_p-16__IzqCo`,
	"mr-10": `paymentBlock_mr-10__XMgb5`,
	"tg-rd-button": `paymentBlock_tg-rd-button__nznFW`,
	"m-0": `paymentBlock_m-0__ZKYMH`,
	"g-line-height-1": `paymentBlock_g-line-height-1__Bhzvz`,
	"glh-1": `paymentBlock_glh-1__px0k5`,
	"w-100": `paymentBlock_w-100__GT58Z`,
	"disabled": `paymentBlock_disabled__oEBND`,
	"form-control-file": `paymentBlock_form-control-file__MbxFl`,
	"btn-sm": `paymentBlock_btn-sm__h10d7`,
	"mb-md-0": `paymentBlock_mb-md-0__LN0i5`,
	"mb-20": `paymentBlock_mb-20__2fQke`,
	"loaderOverlay": `paymentBlock_loaderOverlay__Xhb+H`,
	"mob-btn-width": `paymentBlock_mob-btn-width__GvUhr`
};
export default ___CSS_LOADER_EXPORT___;
